import React, {useState, useContext, useEffect} from 'react';
import axios from 'axios';

import {Dialog, DialogContent, DialogContentText} from '@material-ui/core';

import SuspenseSpinner from 'components/SuspenseSpinner';
import Context from 'utils/Context';
import Conf from 'utils/Conf';

import Multiplex from './Multiplex';

const MultiplexContainer = ({params}) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const {appState} = useContext(Context);

  useEffect(() => {
    axios(`${Conf.apiBaseUriLegacy}/access/event/${params.id}`, {
      params: {
        hash: params.hash,
        uuid: appState.uuid,
      },
    }).then(res => {
      if (res.data.authorized) {
        setHasAccess(true);
        setLoading(false);
      }
    });
  }, [params.id, params.hash, appState.uuid]);

  useEffect(() => {
    if (!hasAccess) return;
    setLoading(true);
    axios
      .get(`${Conf.apiBaseUriLegacy}/event/${params.id}/full`, {
        params: {
          hash: params.hash,
          uuid: appState.uuid,
        },
      })
      .then(res => {
        setData(res.data);
        setLoading(false);
      });
  }, [hasAccess, params.id, params.hash, appState.uuid]);

  if (loading) return <SuspenseSpinner />;

  if (!hasAccess || !data) {
    return (
      <div className="multiplex-container">
        <Dialog open className="my-dialog">
          <DialogContent>
            {/* <DialogContentText>{accessDeniedMsg}</DialogContentText> */}
            <DialogContentText>No access</DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  return <Multiplex data={data} params={params} />;
};

export default MultiplexContainer;
